// Value-band evaluation: steps pick a band, gradient interpolates between the
// two neighbouring bands. Pure (no DOM), used by the HUD runtime and (later) by
// crosshair dynamic rules.

import { mixHex } from "../crosshair/types";
import type { HudBand, HudValuePaint } from "./types";

export function sortedBands(bands: HudBand[]): HudBand[] {
  return [...bands].sort((a, b) => a.min - b.min);
}

/** Index of the last band whose `min <= value` (0 when below all bands). */
export function bandIndex(bands: HudBand[], value: number): number {
  const sorted = sortedBands(bands);
  let idx = 0;
  for (let i = 0; i < sorted.length; i++) {
    if (value >= sorted[i].min) idx = i;
  }
  return idx;
}

export function evaluatePaint(
  paint: HudValuePaint | null | undefined,
  value: number,
): { color: string; index: number } | null {
  if (!paint?.enabled || paint.bands.length === 0) return null;
  const bands = sortedBands(paint.bands);
  if (paint.mode === "gradient") {
    if (value <= bands[0].min) return { color: bands[0].color, index: 0 };
    for (let i = 1; i < bands.length; i++) {
      const a = bands[i - 1];
      const b = bands[i];
      if (value < b.min) {
        const span = b.min - a.min;
        const t = span > 0 ? (value - a.min) / span : 1;
        return { color: mixHex(a.color, b.color, t), index: i - 1 };
      }
    }
    return { color: bands[bands.length - 1].color, index: bands.length - 1 };
  }
  const index = bandIndex(bands, value);
  return { color: bands[index].color, index };
}
